import React from 'react';
import Form from './Form';

const Body = () => {
    return ( 
        <>
            <Form />
        </>
     );
}
 
export default Body;